export default "__VITE_ASSET__gPqrKKxmu_ftAVkCV3XzNw__"